var map = {
	"./new1-1.png": "04e1",
	"./new1-2.png": "51d5",
	"./new1-3.png": "3394",
	"./new2-1.jpg": "385f",
	"./new2-2.jpg": "b56e",
	"./new2-3.jpg": "7e63",
	"./new3-1.jpg": "9403",
	"./new3-2.jpg": "6725",
	"./new3-3.jpg": "f0cc",
	"./new4-1.gif": "214fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f544";